<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-lg-4 col-md-3 col-sm-4 col-8">
        <el-form-item
          :label="L10n('part-number')"
          prop="partID"
          class="material-style"
          :rules="rulePartNumber"
        >
          <select-part-number
            :model.sync="form.partID"
          >
          </select-part-number>
        </el-form-item>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 col-4">
        <el-form-item
          :label="L10n('qty')"
          :rules="getValidationRule('required,numberInteger')"
          prop="qty"
          class="material-style">
          <el-input
            :value="form.qty"
            @input="form.qty = valueNumber($event)"/>
        </el-form-item>
      </div>
      <div class="col-lg-4 col-md-3 col-sm-3 col-12">
        <el-form-item
          :label="L10n('observation')"
          prop="observation"
          class="material-style">
          <el-input
            v-model="form.observation"
          ></el-input>
        </el-form-item>
      </div>
      <div class="col-lg-2 col-md-4 col-sm-3 col-12 d-flex justify-content-center align-items-center">
        <button
          type="button"
          class="btn btn-size-s btn-mobile-full"
          @click="$emit('command', 'save')"
        >{{L10n('create')}}</button>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'Form',
  components: {
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue')
  },
  mixins: [Form],
  props: {
    list: { type: Array, required: true }
  },
  computed: {
    rulePartNumber () {
      return this.getValidationRule('required')
        .concat([
          {
            validator: (rule, value, cb) => {
              if (this.mapList[value]) {
                return cb(new Error(this.L10n('using-already')))
              } else {
                return cb()
              }
            }
          }
        ])
    },
    mapList () {
      return this.list.reduce((result, item) => {
        result[item.partID] = item
        return result
      }, {})
    }
  }
}
</script>
